import { message } from "antd";

import { assertNever } from "./obj";

interface NotificationOptions {
    duration?: NotificationDuration;
}
type NotificationLevel = "error" | "warning" | "info" | "success";
type NotificationDuration = "NORMAL" | "DOUBLE";

function durationToSeconds(duration: NotificationDuration | undefined): number {
    switch (duration) {
        // 3 seconds is the default value from Antd
        case "NORMAL":
        case undefined:
            return 3;
        case "DOUBLE":
            return 6;
        default:
            return assertNever(duration);
    }
}

export function emitNotification(
    level: NotificationLevel,
    msg: string,
    options: NotificationOptions = {}
) {
    const durationInSeconds = durationToSeconds(options.duration);
    switch (level) {
        case "error":
            message.error(msg, durationInSeconds);
            break;
        case "warning":
            message.warning(msg, durationInSeconds);
            break;
        case "info":
            message.info(msg, durationInSeconds);
            break;
        case "success":
            message.success(msg, durationInSeconds);
            break;
        default:
            assertNever(level);
    }
}
